import styled, { keyframes } from "styled-components";

const blinkAnimation = keyframes`
  0%, 100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
`;

export const FormStyles = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0rem 2rem;
  background: transparent;

  &.contact-form {
    h2 {
      text-align: center;
      margin-bottom: 1.5rem;
      font-size: 2rem;
      color: #fff;
    }

    input,
    textarea {
      margin-bottom: 2.1rem;
      padding: 0.5rem;
      width: 80%;
      margin-bottom: 2.1rem;
      padding: 0.5rem;
      background-color: #e0f7fa;
      width: 80%;
      border-radius: 0.4rem;
      border: none;
      outline: none;
      font-size: 1rem;
      box-shadow: 0 0 0.3rem rgb(178, 235, 242);

      &:focus {
        background-color: rgb(178, 235, 242);
      }
    }

    textarea {
      resize: none;
      height: 3rem;
    }

    button {
      display: flex;
      flex-direction: row;
      align-self: left;
      width: auto;
      padding: 0.32rem 1rem;
      background-color: #ff8412;
      border: 0.125rem solid #ff8412;
      border-radius: 0.4rem;
      font-size: 1.25rem;
      cursor: pointer;
      color: #fff;
      animation: ${blinkAnimation} 2s infinite ease-in-out;
    }
  }
`;
